import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';
import {
  House,
  Users,
  Briefcase,
  ListChecks,
  Clock,
  CurrencyDollar,
  Buildings,
  Receipt,
  Storefront,
  Gear,
  SignOut,
  List,
  X,
  CaretLeft,
  CaretRight,
  CaretDown,
  Shield,
  FileText,
  ChartLine,
  Crown,
  ChartBar,
  Bank,
  UserCircle,
  ClipboardText,
  CalendarBlank,
  UserGear,
  Repeat,
  CheckCircle,
  Wallet,
  SunHorizon,
  Truck,
  Handshake,
  GitBranch,
  BuildingOffice,
  Wrench,
  Desktop,
  Package,
  CalendarCheck,
  MapPin,
  Ticket,
  BellRinging,
  BellSimple,
  Scales,
} from '@phosphor-icons/react';

const navItems = [
  { key: 'dashboard', icon: House, path: '/dashboard', roles: ['admin', 'gerencia', 'pm', 'rrhh', 'empleado'] },
  // IT Operations
  { key: 'itDashboard', icon: Wrench, path: '/it/dashboard', roles: ['admin', 'gerencia', 'pm', 'tecnico'] },
  { key: 'itAssets', icon: Desktop, path: '/it/assets', roles: ['admin', 'gerencia', 'pm', 'tecnico', 'empleado'] },
  { key: 'itVisits', icon: CalendarCheck, path: '/it/visits', roles: ['admin', 'gerencia', 'pm', 'tecnico', 'empleado'] },
  { key: 'itLocations', icon: MapPin, path: '/it/locations', roles: ['admin', 'gerencia', 'pm', 'tecnico'] },
  { key: 'itTickets', icon: Ticket, path: '/it/tickets', roles: ['admin', 'gerencia', 'pm', 'tecnico', 'empleado', 'cliente'] },
  { key: 'itMaintenance', icon: Wrench, path: '/it/maintenance', roles: ['admin', 'gerencia', 'pm', 'tecnico'] },
  { key: 'itContracts', icon: Shield, path: '/it/contracts', roles: ['admin', 'gerencia', 'pm', 'tecnico'] },
  { key: 'itSpareParts', icon: Package, path: '/it/spare-parts', roles: ['admin', 'gerencia', 'pm', 'tecnico'] },
  { key: 'itReports', icon: ChartBar, path: '/it/reports', roles: ['admin', 'gerencia', 'pm', 'tecnico'] },
  { key: 'employees', icon: Users, path: '/employees', roles: ['admin', 'rrhh', 'gerencia', 'pm'] },
  { key: 'users', icon: UserGear, path: '/users', roles: ['admin'] },
  { key: 'projects', icon: Briefcase, path: '/projects', roles: ['admin', 'gerencia', 'pm', 'empleado'] },
  { key: 'tasks', icon: ListChecks, path: '/tasks', roles: ['admin', 'gerencia', 'pm', 'empleado'] },
  { key: 'timeTracking', icon: Clock, path: '/time-tracking', roles: ['admin', 'gerencia', 'pm', 'rrhh', 'empleado'] },
  { key: 'timesheetApproval', icon: CheckCircle, path: '/timesheet-approval', roles: ['admin', 'gerencia', 'pm'] },
  { key: 'vacations', icon: SunHorizon, path: '/vacations', roles: ['admin', 'gerencia', 'rrhh', 'pm', 'empleado'] },
  { key: 'marketplace', icon: Storefront, path: '/marketplace', roles: ['admin', 'gerencia', 'pm', 'empleado'] },
  { key: 'payments', icon: CurrencyDollar, path: '/payments', roles: ['admin', 'rrhh', 'gerencia', 'empleado'] },
  { key: 'clients', icon: Buildings, path: '/clients', roles: ['admin', 'gerencia', 'pm'] },
  { key: 'quotationRequests', icon: ClipboardText, path: '/quotation-requests', roles: ['admin', 'gerencia', 'pm'] },
  { key: 'subscriptions', icon: Repeat, path: '/subscriptions', roles: ['admin', 'gerencia', 'pm'] },
  { key: 'invoices', icon: Receipt, path: '/invoices', roles: ['admin', 'gerencia'] },
  { key: 'invoiceReminders', icon: BellRinging, path: '/invoice-reminders', roles: ['admin', 'gerencia'] },
  { key: 'quotations', icon: FileText, path: '/quotations', roles: ['admin', 'gerencia'] },
  { key: 'services', icon: Package, path: '/services', roles: ['admin', 'gerencia'] },
  { key: 'suppliers', icon: Truck, path: '/suppliers', roles: ['admin', 'gerencia', 'pm'] },
  { key: 'billingDashboard', icon: Wallet, path: '/billing-dashboard', roles: ['admin', 'gerencia'] },
  { key: 'accounting', icon: ChartLine, path: '/accounting', roles: ['admin', 'gerencia'] },
  { key: 'taxReports', icon: Scales, path: '/tax-reports', roles: ['admin', 'gerencia'] },
  { key: 'stakeholders', icon: Crown, path: '/stakeholders', roles: ['admin', 'gerencia'] },
  { key: 'reports', icon: ChartBar, path: '/reports', roles: ['admin', 'gerencia', 'pm'] },
  { key: 'capacityPlanning', icon: CalendarBlank, path: '/capacity-planning', roles: ['admin', 'gerencia', 'pm'] },
  { key: 'bank', icon: Bank, path: '/bank', roles: ['admin', 'gerencia'] },
  { key: 'auditLog', icon: Shield, path: '/audit-log', roles: ['admin', 'gerencia'] },
  { key: 'crm', icon: Handshake, path: '/crm', roles: ['admin', 'gerencia', 'pm', 'ventas'] },
  { key: 'workflows', icon: GitBranch, path: '/workflows', roles: ['admin', 'gerencia', 'pm', 'rrhh'] },
  { key: 'companies', icon: BuildingOffice, path: '/companies', roles: ['admin', 'gerencia'] },
  { key: 'clientPortal', icon: UserCircle, path: '/client-portal', roles: ['admin', 'gerencia', 'cliente'] },
  { key: 'notificationPreferences', icon: BellSimple, path: '/notification-preferences', roles: ['admin', 'gerencia', 'pm', 'rrhh', 'empleado', 'tecnico', 'ventas', 'cliente'] },
];

const navGroups = [
  {
    key: 'hr',
    labelKey: 'groupHR',
    icon: Users,
    items: ['employees', 'vacations', 'timeTracking', 'timesheetApproval'],
  },
  {
    key: 'projects',
    labelKey: 'groupProjects',
    icon: Briefcase,
    items: ['projects', 'tasks', 'capacityPlanning', 'workflows'],
  },
  {
    key: 'sales',
    labelKey: 'groupSales',
    icon: Handshake,
    items: ['crm', 'clients', 'quotationRequests', 'quotations', 'subscriptions', 'services', 'marketplace'],
  },
  {
    key: 'finance',
    labelKey: 'groupFinance',
    icon: Wallet,
    items: ['invoices', 'invoiceReminders', 'payments', 'billingDashboard', 'accounting', 'taxReports', 'bank', 'suppliers'],
  },
  {
    key: 'it',
    labelKey: 'groupIT',
    icon: Wrench,
    items: ['itDashboard', 'itTickets', 'itVisits', 'itAssets', 'itMaintenance', 'itLocations', 'itContracts', 'itSpareParts', 'itReports'],
  },
  {
    key: 'admin',
    labelKey: 'groupAdmin',
    icon: Gear,
    items: ['users', 'companies', 'stakeholders', 'reports', 'auditLog', 'clientPortal', 'notificationPreferences'],
  },
];

const STANDALONE_KEYS = new Set(['dashboard']);

export function Sidebar() {
  const { user, logout } = useAuth();
  const { t } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const filteredNavItems = navItems.filter(item => item.roles.includes(user?.role));
  const itemByKey = Object.fromEntries(filteredNavItems.map(i => [i.key, i]));
  const standaloneItems = filteredNavItems.filter(i => STANDALONE_KEYS.has(i.key));
  const groupedKeys = new Set(navGroups.flatMap(g => g.items));
  const ungroupedItems = filteredNavItems.filter(i => !STANDALONE_KEYS.has(i.key) && !groupedKeys.has(i.key));
  const renderableGroups = navGroups
    .map(g => ({ ...g, visibleItems: g.items.map(k => itemByKey[k]).filter(Boolean) }))
    .filter(g => g.visibleItems.length > 0);

  const isItemActive = (item) =>
    location.pathname === item.path || location.pathname.startsWith(item.path + '/');

  const [openGroups, setOpenGroups] = useState({});

  useEffect(() => {
    setOpenGroups(prev => {
      const next = { ...prev };
      navGroups.forEach(g => {
        const anyActive = g.items.some(key => {
          const item = navItems.find(i => i.key === key);
          return item && (location.pathname === item.path || location.pathname.startsWith(item.path + '/'));
        });
        if (anyActive) next[g.key] = true;
      });
      return next;
    });
  }, [location.pathname]);

  const toggleGroup = (key) => setOpenGroups(prev => ({ ...prev, [key]: !prev[key] }));

  const SidebarContent = () => (
    <div className="flex flex-col h-full">
      {/* Logo */}
      <div className="p-4 border-b border-[#242E42]">
        <Link to="/dashboard" className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-[#E2B05E] to-[#F0C47A] flex items-center justify-center">
            <Shield weight="fill" className="w-6 h-6 text-[#0B0E14]" />
          </div>
          {!collapsed && (
            <div className="flex flex-col">
              <span className="font-['Outfit'] font-bold text-[#F3F4F6] text-lg tracking-tight">VALHALLA</span>
              <span className="text-[10px] text-[#9CA3AF] tracking-[0.15em] uppercase">Corporations</span>
            </div>
          )}
        </Link>
      </div>

      {/* Nav Items */}
      <nav className="flex-1 p-3 space-y-1 overflow-y-auto">
        {collapsed && filteredNavItems.map((item) => {
          const Icon = item.icon;
          const isActive = isItemActive(item);
          return (
            <Link
              key={item.key}
              to={item.path}
              onClick={() => setMobileOpen(false)}
              className={`sidebar-item flex items-center justify-center gap-3 px-3 py-2.5 rounded-lg transition-all duration-200 ${
                isActive
                  ? 'bg-[#E2B05E]/10 text-[#E2B05E] active'
                  : 'text-[#9CA3AF] hover:bg-[#1E2636] hover:text-[#F3F4F6]'
              }`}
              data-testid={`sidebar-${item.key}`}
              title={t(item.key)}
            >
              <Icon weight={isActive ? 'fill' : 'regular'} className="w-5 h-5 flex-shrink-0" />
            </Link>
          );
        })}

        {!collapsed && standaloneItems.map((item) => {
          const Icon = item.icon;
          const isActive = isItemActive(item);
          return (
            <Link
              key={item.key}
              to={item.path}
              onClick={() => setMobileOpen(false)}
              className={`sidebar-item flex items-center gap-3 px-3 py-2.5 rounded-lg transition-all duration-200 ${
                isActive
                  ? 'bg-[#E2B05E]/10 text-[#E2B05E] active'
                  : 'text-[#9CA3AF] hover:bg-[#1E2636] hover:text-[#F3F4F6]'
              }`}
              data-testid={`sidebar-${item.key}`}
            >
              <Icon weight={isActive ? 'fill' : 'regular'} className="w-5 h-5 flex-shrink-0" />
              <span className="text-sm font-medium">{t(item.key)}</span>
            </Link>
          );
        })}

        {!collapsed && renderableGroups.map((group) => {
          const GroupIcon = group.icon;
          const isOpen = !!openGroups[group.key];
          const hasActiveChild = group.visibleItems.some(isItemActive);
          return (
            <div key={group.key} className="mt-2">
              <button
                type="button"
                onClick={() => toggleGroup(group.key)}
                className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg transition-all duration-200 ${
                  hasActiveChild
                    ? 'text-[#E2B05E]'
                    : 'text-[#9CA3AF] hover:bg-[#1E2636] hover:text-[#F3F4F6]'
                }`}
                data-testid={`sidebar-group-${group.key}`}
                aria-expanded={isOpen}
              >
                <GroupIcon weight={hasActiveChild ? 'fill' : 'regular'} className="w-5 h-5 flex-shrink-0" />
                <span className="text-[11px] font-semibold uppercase tracking-[0.16em] flex-1 text-left">
                  {t(group.labelKey)}
                </span>
                <CaretDown
                  className={`w-3.5 h-3.5 flex-shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-0' : '-rotate-90'}`}
                />
              </button>
              {isOpen && (
                <div className="mt-1 ml-3 pl-3 border-l border-[#242E42] space-y-1">
                  {group.visibleItems.map((item) => {
                    const Icon = item.icon;
                    const isActive = isItemActive(item);
                    return (
                      <Link
                        key={item.key}
                        to={item.path}
                        onClick={() => setMobileOpen(false)}
                        className={`sidebar-item flex items-center gap-3 px-3 py-2 rounded-lg transition-all duration-200 ${
                          isActive
                            ? 'bg-[#E2B05E]/10 text-[#E2B05E] active'
                            : 'text-[#9CA3AF] hover:bg-[#1E2636] hover:text-[#F3F4F6]'
                        }`}
                        data-testid={`sidebar-${item.key}`}
                      >
                        <Icon weight={isActive ? 'fill' : 'regular'} className="w-4 h-4 flex-shrink-0" />
                        <span className="text-sm font-medium">{t(item.key)}</span>
                      </Link>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}

        {!collapsed && ungroupedItems.map((item) => {
          const Icon = item.icon;
          const isActive = isItemActive(item);
          return (
            <Link
              key={item.key}
              to={item.path}
              onClick={() => setMobileOpen(false)}
              className={`sidebar-item flex items-center gap-3 px-3 py-2.5 rounded-lg transition-all duration-200 ${
                isActive
                  ? 'bg-[#E2B05E]/10 text-[#E2B05E] active'
                  : 'text-[#9CA3AF] hover:bg-[#1E2636] hover:text-[#F3F4F6]'
              }`}
              data-testid={`sidebar-${item.key}`}
            >
              <Icon weight={isActive ? 'fill' : 'regular'} className="w-5 h-5 flex-shrink-0" />
              <span className="text-sm font-medium">{t(item.key)}</span>
            </Link>
          );
        })}
      </nav>

      {/* User Section */}
      <div className="p-3 border-t border-[#242E42]">
        <div className={`flex items-center gap-3 px-3 py-2 ${collapsed ? 'justify-center' : ''}`}>
          <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#3AB8D6] to-[#2A8FA8] flex items-center justify-center text-white font-medium text-sm">
            {user?.name?.charAt(0)?.toUpperCase() || 'U'}
          </div>
          {!collapsed && (
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-[#F3F4F6] truncate">{user?.name}</p>
              <p className="text-xs text-[#9CA3AF] capitalize">{user?.role}</p>
            </div>
          )}
        </div>
        
        <button
          onClick={handleLogout}
          className="w-full flex items-center gap-3 px-3 py-2.5 mt-2 rounded-lg text-[#9CA3AF] hover:bg-red-500/10 hover:text-red-400 transition-all duration-200"
          data-testid="logout-btn"
        >
          <SignOut className="w-5 h-5 flex-shrink-0" />
          {!collapsed && <span className="text-sm font-medium">{t('logout')}</span>}
        </button>
      </div>

      {/* Collapse Button - Desktop */}
      <button
        onClick={() => setCollapsed(!collapsed)}
        className="hidden lg:flex absolute -right-3 top-20 w-6 h-6 rounded-full bg-[#242E42] border border-[#242E42] items-center justify-center text-[#9CA3AF] hover:text-[#F3F4F6] hover:bg-[#1E2636] transition-all"
      >
        {collapsed ? <CaretRight className="w-3 h-3" /> : <CaretLeft className="w-3 h-3" />}
      </button>
    </div>
  );

  return (
    <>
      {/* Mobile Menu Button */}
      <button
        onClick={() => setMobileOpen(true)}
        className="lg:hidden fixed top-4 left-4 z-50 p-2 rounded-lg bg-[#151B26] border border-[#242E42] text-[#F3F4F6]"
        data-testid="mobile-menu-btn"
      >
        <List className="w-5 h-5" />
      </button>

      {/* Mobile Overlay */}
      {mobileOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black/50 z-40"
          onClick={() => setMobileOpen(false)}
        />
      )}

      {/* Mobile Sidebar */}
      <aside
        className={`lg:hidden fixed inset-y-0 left-0 z-50 w-64 bg-[#151B26] border-r border-[#242E42] transform transition-transform duration-300 ${
          mobileOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <button
          onClick={() => setMobileOpen(false)}
          className="absolute top-4 right-4 p-1 rounded text-[#9CA3AF] hover:text-[#F3F4F6]"
        >
          <X className="w-5 h-5" />
        </button>
        <SidebarContent />
      </aside>

      {/* Desktop Sidebar */}
      <aside
        className={`hidden lg:block fixed inset-y-0 left-0 z-30 bg-[#151B26] border-r border-[#242E42] transition-all duration-300 ${
          collapsed ? 'w-[72px]' : 'w-64'
        }`}
      >
        <SidebarContent />
      </aside>

      {/* Spacer */}
      <div className={`hidden lg:block flex-shrink-0 transition-all duration-300 ${collapsed ? 'w-[72px]' : 'w-64'}`} />
    </>
  );
}

export default Sidebar;
